import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

type Environment = { country: string; isProductionEnv: boolean };

function getEnvironment(): Environment {
    const environment: Environment = {
        country: 'uk',
        isProductionEnv: false
    };
    const location = window.location;

    if (['www.iwoca.de', 'stage.iwoca-dev.de'].includes(location.hostname)) {
        environment.country = 'de';
    }
    if (['www.iwoca.co.uk', 'www.iwoca.de'].includes(location.hostname)) {
        environment.isProductionEnv = true;
    }
    return environment;
}

function getBaseDatadogConfig(environment: Environment) {
    return {
        service: 'pandora',
        version: `${process.env.REACT_APP_RELEASE}`,
        env: environment.country,
        site: 'datadoghq.com' as const
    };
}

const rumConfiguration: Partial<RumInitConfiguration> = {
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    actionNameAttribute: 'data-action-name'
};

const logsConfiguration: Partial<LogsInitConfiguration> = {
    forwardErrorsToLogs: true,
    sessionSampleRate: 100
};

export function initialise() {
    const environment = getEnvironment();
    const baseConfig = getBaseDatadogConfig(environment);

    if (environment.isProductionEnv) {
        datadogLogs.init({
            ...baseConfig,
            ...logsConfiguration,
            clientToken: 'puba24e31fd07eebf922780e6779336c22e'
        });
        datadogRum.init({
            ...baseConfig,
            ...rumConfiguration,
            clientToken: 'pub3c54e432b399f0df228a472b574f901c',
            applicationId: '904a16f5-6288-4342-be26-462d779fb422',
            allowedTracingUrls: [
                'https://www.iwoca.co.uk',
                'https://www.iwoca.de'
            ]
        });
    } else {
        datadogLogs.init({
            ...baseConfig,
            ...logsConfiguration,
            clientToken: 'pub2e298b1b8f3416600735801c004cef84'
        });
        datadogRum.init({
            ...baseConfig,
            ...rumConfiguration,
            clientToken: 'pubfa2860ebf80dd5ba1cc0f426a25783f9',
            applicationId: '00c28314-af53-4689-99ff-843c0d21b601',
            allowedTracingUrls: [
                'https://stage.iwoca-dev.co.uk',
                'https://stage.iwoca-dev.de'
            ]
        });
    }
}

export function logError(
    message: string,
    messageContext?: object,
    error?: Error
) {
    datadogLogs.logger.error(message, messageContext, error);
}

export function logInfo(message: string, messageContext?: object) {
    datadogLogs.logger.info(message, messageContext);
}

export function identifyUser(context: {
    state_key: string;
    impersonating: boolean;
}) {
    datadogLogs.setGlobalContextProperty('state_key', context.state_key);
    datadogLogs.setGlobalContextProperty(
        'impersonating',
        context.impersonating
    );
    datadogRum.setGlobalContextProperty('state_key', context.state_key);
    datadogRum.setGlobalContextProperty('impersonating', context.impersonating);
}

export const TAGS = {
    DE_LENDING: { team: 'de-lending-frontend' },
    DE_BYG: { team: 'de-byg' }
};
